import { Link } from "react-router";
import { Panel } from "@/components/ui/panel";
import { Button } from "@/components/ui/button";

export function BillingReturnPage({ kind }: { kind: "success" | "cancel" }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-rs-bg px-4">
      <Panel className="w-full max-w-md space-y-4 p-8 text-center">
        <h1 className="text-xl font-semibold text-rs-ink">
          {kind === "success" ? "Billing Updated" : "Billing Cancelled"}
        </h1>
        <p className="text-sm text-rs-ink-muted">
          {kind === "success"
            ? "Your subscription checkout completed. Active streams and attendee usage will appear on your next invoice."
            : "Checkout was cancelled. No paid subscription was started."}
        </p>
        <div className="flex flex-wrap justify-center gap-2">
          <Button asChild variant="secondary">
            <Link to="/settings/billing">Open Settings Billing</Link>
          </Button>
          <Button asChild>
            <Link to="/">Return to Portal</Link>
          </Button>
        </div>
      </Panel>
    </div>
  );
}

/** Legacy invite links — invitations are no longer supported. */
export function InviteAcceptPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-rs-bg px-4">
      <Panel className="w-full max-w-md space-y-4 p-8 text-center">
        <h1 className="text-xl font-semibold text-rs-ink">
          Invitations Unavailable
        </h1>
        <p className="text-sm text-rs-ink-muted">
          Workspace invitations are no longer supported. Each user has a private
          solo workspace. Sign up for a new account if you need your own
          workspace.
        </p>
        <div className="flex flex-wrap justify-center gap-2">
          <Button asChild variant="secondary">
            <Link to="/signup">Create Account</Link>
          </Button>
          <Button asChild>
            <Link to="/login">Sign In</Link>
          </Button>
        </div>
      </Panel>
    </div>
  );
}
